'use strict';

/* globals gui */

var at = require('./environment');

var isLightboxLoaded = false;
var newPlayerInstancesQueue = [];
var lightboxCheckTimer;


function newPlayerInstance(element) {
    if (isLightboxLoaded) gui.lightbox.lightbox(element, {});
    else newPlayerInstancesQueue.push(element);
}

function checkLightboxLoadingState() {
    if (window.gui && gui.lightbox) {
        isLightboxLoaded = true;
        while (newPlayerInstancesQueue.length > 0)
            newPlayerInstance(newPlayerInstancesQueue.shift());
        clearTimeout(lightboxCheckTimer);
    }
    else lightboxCheckTimer = setTimeout(checkLightboxLoadingState, 1000);
}
if (at.client) checkLightboxLoadingState();

module.exports = newPlayerInstance;
